// export const UspId = 'usp';
export const ContactId = 'contact';
export const DocsId = 'docs';
